let tabsInitialized = false;

function debounce(func, wait = 100) {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
}

function initTabs(tabs, sections) {
  tabs.forEach(tab => {
    tab.addEventListener('click', function (e) {
      e.preventDefault();

      const targetId = this.getAttribute('data-target');
      const targetSection = document.getElementById(targetId);

      if (targetSection) {
        sections.forEach(section => section.classList.remove('active'));
        targetSection.classList.add('active');
      } else {
        console.error(`Section ID not found.`);
      }
    });
  });
}

function setupTabListeners() {
  const tabs = document.querySelectorAll('.tab-link');
  const sections = document.querySelectorAll('.menu-section');

  if (tabs.length > 0 && sections.length > 0 && !tabsInitialized) {
    initTabs(tabs, sections);
    tabsInitialized = true;
  } else if (!tabsInitialized) {
    console.warn('Tabs are waiting for elements...');
  }
}

const handleMutations = debounce(() => {
  const tabs = document.querySelectorAll('.tab-link');
  const sections = document.querySelectorAll('.menu-section');

  if (tabs.length > 0 && sections.length > 0 && !tabsInitialized) {
    setupTabListeners();
  }
}, 100);

const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
      handleMutations();
    }
  });
});

observer.observe(document.body, { childList: true, subtree: true });

document.addEventListener('DOMContentLoaded', () => {
  setupTabListeners();
});
